import React, { Component } from 'react'
import { Link } from 'react-router-dom'

import * as routes from '../constants/routes'
import { MailToLink, CopyrightText } from './StyledComponents/Footer'

class Footer extends Component {
    render() {
        const thisYear = new Date().getFullYear()

        return (
            <footer id="myFooter">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-3">
                            <h5><Link to="/">Smart Garden Assistant</Link></h5>
                        </div>
                        <div className="col-sm-2">
                            <h5>General</h5>
                            <ul>
                                <li><Link to={routes.LANDING}>Home</Link></li>
                                <li><Link to={routes.IMPRESSUM}>Impressum</Link></li>
                                <li><Link to={routes.PRIVACY_POLICY}>Datenschutz</Link></li>
                            </ul>
                        </div>
                        <div className="col-sm-2">
                            <h5>Profile</h5>
                            <ul>
                                <li><Link to={routes.SIGN_UP}>Registrieren</Link></li>
                                <li><Link to={routes.SIGN_IN}>Einloggen</Link></li>
                            </ul>
                        </div>
                        <div className="col-sm-2">
                            <h5>Support</h5>
                            <ul>
                                {/* <li><Link to={routes.FAQ}>FAQ</Link></li> */}
                                <li><a href={routes.FLOWERAI_WEBSITE}>Flower AI</a></li>
                            </ul>
                        </div>
                        <div className="col-sm-3">
                            <div className="social-networks">
                                <a href="https://twitter.com/philiplenhart" className="twitter"><i className="fa fa-twitter" /></a>
                                <a href="https://www.facebook.com/philip.lenhart" className="facebook"><i className="fa fa-facebook" /></a>
                            </div>
                            <button type="button" className="btn btn-default"><MailToLink href="mailto:dev@philiplenhart.de?subject=Smart%20garden%20assistant">Email</MailToLink></button>
                        </div>
                    </div>
                </div>
                <CopyrightText>
                    <p>© 2018 {thisYear === 2018 ? '' : ` - ${thisYear}`} Philip Lenhart </p>
                </CopyrightText>
            </footer>
        )
    }
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer.js